import React from 'react';
import { Formik } from 'formik';

import { IntegrationTableFormValues } from '../types/integration.types';

const initialValues: IntegrationTableFormValues = {
	integrationType: undefined,
};

export default function IntegrationsViewForm({
	children,
}: {
	children: React.ReactNode;
}) {
	return (
		<Formik initialValues={initialValues} onSubmit={() => void 0}>
			{() => <div>{children}</div>}
		</Formik>
	);
}
